import React, {useCallback} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import {ForwardToInbox} from '@mui/icons-material';

/**
 * Icon button that opens the resend-activation dialog for an On Hold member.
 * @param {object} props
 * @param {string} props.label
 * @param {() => void} props.onClick
 */
const ResendActivationIconButton = ({label, onClick}) => {
    /**
     * Opens the dialog without letting the grid treat the click as a row selection.
     * @type {(function(React.MouseEvent<HTMLButtonElement>): void)}
     */
    const handleClick = useCallback((event) => {
        event.stopPropagation();
        onClick?.();
    }, [onClick]);

    return (
        <Tooltip title={label}>
            <IconButton
                size="small"
                color="secondary"
                aria-label={label}
                onClick={handleClick}
            >
                <ForwardToInbox fontSize="small"/>
            </IconButton>
        </Tooltip>
    );
};

export default ResendActivationIconButton;
